export default __webpack_public_path__ + "static/media/gallery_06.2c60e965.jpg";